import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

interface CarouselControlsProps {
  onPrevious: () => void;
  onNext: () => void;
  canGoNext: boolean;
  canGoPrevious: boolean;
}

export default function CarouselControls({
  onPrevious,
  onNext,
  canGoNext,
  canGoPrevious
}: CarouselControlsProps) {
  return (
    <div className="flex justify-center mt-8 space-x-4">
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={onPrevious}
        disabled={!canGoPrevious}
        className={`p-3 rounded-full ${
          canGoPrevious
            ? 'bg-primary text-dark hover:bg-primary-hover'
            : 'bg-gray-100 text-gray-400 cursor-not-allowed'
        }`}
      >
        <ChevronLeft className="w-6 h-6" />
      </motion.button>
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={onNext}
        disabled={!canGoNext}
        className={`p-3 rounded-full ${
          canGoNext
            ? 'bg-primary text-dark hover:bg-primary-hover'
            : 'bg-gray-100 text-gray-400 cursor-not-allowed'
        }`}
      >
        <ChevronRight className="w-6 h-6" />
      </motion.button>
    </div>
  );
}